import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontSourceSerif4, styleToggle, theme } from "shared/lib/styles";

export const Container = styled.div<{ $articleCount?: number; $hasLabel?: boolean }>`
  display: grid;

  ${({ $articleCount, $hasLabel = false }) => css`
    grid-template-areas:
      ${styleToggle($hasLabel, '"label"')}
      "primary-article-image-carousel"
      "primary-article"
      "secondary-articles";
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;

    ${theme.breakpoints.up("tablet")} {
      grid-template-areas:
        ${styleToggle($hasLabel, '"label label"')}
        "primary-article secondary-articles"
        "primary-article-image-carousel primary-article-image-carousel";
      grid-template-columns: minmax(0, 1fr) minmax(0, 340px);
      gap: 24px;

      padding-block: 0;
      border-block: none;
    }

    ${theme.breakpoints.up("desktop")} {
      grid-template:
        ${styleToggle($hasLabel, '"label label" auto')}
        "primary-article primary-article-image-carousel" auto
        "secondary-articles primary-article-image-carousel" auto
        "secondary-articles primary-article-image-carousel" 1fr / 464px minmax(0, 1fr);
      gap: 16px 24px;
    }

    ${$articleCount === 1 &&
    css`
      grid-template-areas:
        ${styleToggle($hasLabel, '"label"')}
        "primary-article-image-carousel"
        "primary-article";

      ${theme.breakpoints.up("tablet")} {
        grid-template-areas:
          ${styleToggle($hasLabel, '"label label"')}
          "primary-article primary-article-image-carousel";
        align-items: center;
      }

      ${theme.breakpoints.up("desktop")} {
        grid-template:
          ${styleToggle($hasLabel, '"label primary-article-image-carousel" auto')}
          "primary-article primary-article-image-carousel" 1fr / minmax(0, 1fr) minmax(0, 1fr);
      }
    `}

    ${$articleCount === 2 &&
    css`
      ${theme.breakpoints.up("desktop")} {
        grid-template-areas:
          ${styleToggle($hasLabel, '"label primary-article-image-carousel"')}
          "primary-article primary-article-image-carousel"
          "secondary-articles primary-article-image-carousel"
          "secondary-articles primary-article-image-carousel";
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      }
    `}
  `}
`;

export const Label = styled.div`
  grid-area: label;

  display: flex;
  flex-direction: column;
  row-gap: 8px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 110%;
  letter-spacing: -4%;
  overflow-wrap: break-word;

  ${theme.breakpoints.up("tablet")} {
    font-size: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 8px;

    font-size: 40px;
  }
`;

export const SecondaryArticles = styled.div`
  grid-area: secondary-articles;

  display: flex;
  flex-direction: column;
  row-gap: 12px;

  padding-block-start: 12px;
  border-block-start: 1px solid #dfdfdf;

  ${theme.breakpoints.up("tablet")} {
    row-gap: 16px;

    max-inline-size: 340px;
    padding-block-start: 0;
    padding-inline-start: 20px;
    border-block-start: none;
    border-inline-start: 1px solid #dfdfdf;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: none;
    padding-block-start: 16px;
    padding-inline-start: 0;
    border-block-start: 1px solid #dfdfdf;
    border-inline-start: none;
  }

  > div:last-of-type {
    flex-grow: 1;
  }

  > div:not(:first-of-type) {
    padding-block-start: 12px;
    border-block-start: 1px solid #dfdfdf;

    ${theme.breakpoints.up("tablet")} {
      padding-block-start: 16px;
    }
  }
`;
